// @ts-ignore
// export default typeof(import.meta.env.DEV) === "boolean" ? import.meta.env.DEV : true;
export default import.meta.env.VITE_DEBUG;
